<!--Select theme-->
<div class="theme-selector" *ngIf="ShowThemeToggle">
    <mat-form-field appearance="filled">
      <!--<fa-icon matPrefix [icon]="faPalette"></fa-icon>-->
      <mat-select [(value)]="SelectedTheme" class="varios">
        <mat-option *ngFor="let theme of themes" [value]="theme">
          {{ theme }}
        </mat-option>
      </mat-select>
    </mat-form-field>
</div>
